import { format, isValid, parse } from 'date-fns';
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import { ICON_ALIASES } from '_constants/icons';
import { theme } from '_constants/theme';
import { hexToRGBA } from '_helpers/theme';

import Icon from 'components/atomic/Icon';
import Text from 'components/atomic/layouts/Text';

const StyledContainer = styled.div`
  border: 1px solid ${hexToRGBA(theme.colors.gray.secondary, 0.16)};
  border-radius: 8px;
`;

const StyledBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.spaces.regular}px;
  padding: ${theme.spaces.small}px;
`;

const StyledRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: ${theme.spaces.smallX}px;
`;

const StyledCol = styled.div`
  &:nth-child(2) {
    flex-grow: 1;
  }
`;

const StyledIconContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40px;
  width: 40px;
  border-radius: 50%;
  background: ${theme.colors.gray.secondary};

  svg {
    fill: ${theme.colors.white};
  }
`;

const StyledDownloadIconContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 24px;
  width: 24px;
  padding: ${theme.spaces.small2X}px;
  border-radius: 8px;
  border: 1px solid ${hexToRGBA(theme.colors.gray.secondary, 0.16)};
  background: ${hexToRGBA(theme.colors.gray.secondary, 0.08)};
  cursor: pointer;
`;

const FilesListItem = ({ id, fileName, description, startDate, endDate, type, onDownload }) => {
  const handleDownload = () => {
    onDownload && onDownload(id, fileName);
  };

  const parsedStartDate = parse(startDate, 'yyyy-MM-dd', new Date());
  const parsedEndDate = parse(endDate, 'yyyy-MM-dd', new Date());

  return (
    <StyledContainer>
      <StyledBody>
        <StyledRow>
          <StyledCol>
            <StyledIconContainer>
              <Icon alias={ICON_ALIASES.checkbox} color={theme.colors.gray.secondary} />
            </StyledIconContainer>
          </StyledCol>
          <StyledCol>
            <Text size={theme.fontSizes.medium} weight={700}>
              {isValid(parsedEndDate) ? format(parsedEndDate, 'MMMM') : endDate} Books
            </Text>
            <Text size={theme.fontSizes.small} weight={700} bottomSpace={theme.spaces.small2X}>
              {description}
            </Text>
            <Text size={theme.fontSizes.small} color={theme.colors.gray.secondary}>
              Start date: {isValid(parsedStartDate) ? format(parsedStartDate, 'MM/dd/yyyy') : startDate}
            </Text>
            <Text size={theme.fontSizes.small} color={theme.colors.gray.secondary}>
              End Date: {isValid(parsedEndDate) ? format(parsedEndDate, 'MM/dd/yyyy') : endDate}
            </Text>
            <Text size={theme.fontSizes.small} color={theme.colors.gray.secondary}>
              Type: {type?.replace(/([A-Z])/g, ' $1').trim()}
            </Text>
          </StyledCol>
          <StyledCol>
            <StyledDownloadIconContainer onClick={handleDownload}>
              <Icon alias={ICON_ALIASES.arrowDownCircle} color={theme.colors.gray.secondary} />
            </StyledDownloadIconContainer>
          </StyledCol>
        </StyledRow>
      </StyledBody>
    </StyledContainer>
  );
};

FilesListItem.propTypes = {
  id: PropTypes.string,
  fileName: PropTypes.string,
  description: PropTypes.string,
  startDate: PropTypes.string,
  endDate: PropTypes.string,
  type: PropTypes.string,
  onDownload: PropTypes.func,
};

export default FilesListItem;
